
import { availableLocales } from 'bits/locale'
import { Component, Prop, Vue } from 'bits/vue'
import OzBackButton from 'library/v4/components/OzBackButton.vue'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import OzDrawerDraggable from 'library/v4/components/OzDrawerDraggable.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzMenuRows, {
  OzMenuRowsFocusStyle,
  OzMenuRowsRow,
  OzMenuRowsSizePreset,
} from 'library/v4/components/OzMenuRows.vue'
import OzPopoverModal from 'library/v4/components/OzPopoverModal.vue'
import type { PopoverAnchor } from 'types'

@Component({
  components: { OzPopoverModal, OzDrawerDraggable, OzBox, OzMenuRows, OzIcon, OzBackButton, OzContainedButton },
})
export default class LocaleMenu extends Vue {
  OzBoxColors = OzBoxColors
  OzMenuRowsSizePreset = OzMenuRowsSizePreset
  OzMenuRowsFocusStyle = OzMenuRowsFocusStyle
  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  OzContainedButtonSizePreset = OzContainedButtonSizePreset

  @Prop({ default: () => [] }) boxClasses!: string[]
  @Prop({ default: 'en' }) currentLocale!: string
  @Prop({
    default: () => {
      return {}
    },
  })
  anchor!: Partial<PopoverAnchor>
  @Prop({ default: 304 }) width!: number
  @Prop({ default: true }) xPopoverTip!: boolean
  @Prop({ default: true }) isPhone!: boolean
  @Prop({ required: true }) windowHeight!: number
  @Prop({ default: undefined }) preferredTrayStartHeight?: number
  @Prop({ default: true }) xBackButton!: boolean
  @Prop({ default: false }) xCloseButton!: boolean
  @Prop({ default: true }) xHeader!: boolean

  get rowData(): OzMenuRowsRow[] {
    return availableLocales.map((locale) => {
      return {
        text: locale.name,
        rightIcon: this.currentLocale === locale.html ? 'checkmark_thicker' : '',
        rightIconHighlighted: true,
        eventPayload: locale.html,
        ref: locale.html,
        testId: `${locale.standard}LanguageMenuRow`,
      }
    })
  }
}
